//import { datiTitolareEff, } from './sezioni/sezioniAnagrafica';
import { datiTitolareEff, } from './sezioni/sezioniAnagraficaTitolareEff';

export const titolareEff = {
  anagraficaValida: null,
  controlloDati: '',  
//  errorFiduciante: false,
  errorFiducianteContoProprio: false,
  errorFiducianteContoTerzi: false,
  errorFiducianteInLista: false,
  datiTitolareEff: datiTitolareEff,
};


export const titolareEffList = [

];